import { StyledCenteredStack } from "web_myplann/Shared/Components/StyledCenteredStack";
import { RowSkeletonLoader } from "web_myplann/Shared/RowSkeletonLoader";

export const DetailSectionLoader = () => (
	<StyledCenteredStack spacing={2} px={5}>
		<RowSkeletonLoader delay={0} />
		<RowSkeletonLoader delay={200} />
		<RowSkeletonLoader delay={400} />
	</StyledCenteredStack>
);
